




















































import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import {
  SfAccordion,
  SfButton,
  SfFilter,
  SfHeading,
  SfRadio,
  SfSidebar,
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { getFilterConfig } from '~/modules/catalog/category/config/FiltersConfig';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'CategoryFilters',
  components: {
    SkeletonLoader,
    CheckboxType: () => import('~/modules/catalog/category/components/filters/renderer/CheckboxType.vue'),
    SwatchColorType: () => import('~/modules/catalog/category/components/filters/renderer/SwatchColorType.vue'),
    RadioType: () => import('~/modules/catalog/category/components/filters/renderer/RadioType.vue'),
    YesNoType: () => import('~/modules/catalog/category/components/filters/renderer/YesNoType.vue'),
    SizeType: () => import('~/modules/catalog/category/components/filters/renderer/SizeType.vue'),
    HeightType: () => import('~/modules/catalog/category/components/filters/renderer/HeightType.vue'),
    SfSidebar,
    SfHeading,
    SfAccordion,
    SfFilter,
    SfButton,
    SfRadio,
    SvgImage,
  },
  props: {},
  setup() {
    const {
      selectedFilters, removableFilters, filters, isLoading, isFilterDisabled,
      selectFilter, doRemoveFilter, doApplyFilters, doClearFilters,
    }: any = inject('UseFiltersProvider');
    const {
      isFilterSidebarOpen, toggleFilterSidebar, isDesktopFiltersOpen, toggleDesktopFilters,
    } = useUiState();

    const order = ['att_by_type', 'size_swatch', 'att_height_options', 'color', 'att_fabric', 'att_by_material',
      'att_climbing_options', 'att_by_design', 'manufacturer', 'att_weight_capacity', 'price', 'att_quick_ship',
      'sale', 'new', 'further_reduced'];
    const sortedFilters = computed(() => (
      [...(filters.value || [])].sort((a, b) => order.indexOf(a.attribute_code) - order.indexOf(b.attribute_code))
    ));

    return {
      selectFilter,
      doApplyFilters,
      doRemoveFilter,
      doClearFilters,
      getFilterConfig,
      selectedFilters,
      filters: sortedFilters,
      isLoading,
      removableFilters,
      isFilterSidebarOpen,
      toggleFilterSidebar,
      isDesktopFiltersOpen,
      toggleDesktopFilters,
      isFilterDisabled,
    };
  },
});
